import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { getJSON, postJSON } from '../../shared/util';
import _ from 'underscore';

export function* get({ payload }) {
    let [user, notifications] = yield all([
        select(state => state.user),
        select(state => state.notifications),
    ]);

    if (user.logged_in) {
        const sessionLI = sessionStorage.getItem('NCLIState');

        if (sessionLI && _.isEqual(JSON.parse(sessionLI).map(obj => obj.code).sort(), payload.codes.sort())) {
            notifications = JSON.parse(sessionLI);
        } else {
            const urlCodes = payload.codes.map((code, i, arr) => {
                return (arr.length - 1 === i) ? 'codes[]=' + code : 'codes[]=' + code + '&';
            }).join('');
            notifications = yield call(getJSON, `/api/notifications?${urlCodes}`);
        }
    } else {
        const sessionLO = sessionStorage.getItem('NCLOState');
        if (sessionLO && _.isEqual(JSON.parse(sessionLO).map(obj => obj.code).sort(), payload.codes.sort())) {
            notifications = JSON.parse(sessionLO);
        } else {
            notifications = payload.codes.map(code => ({ code: code, viewed: false }));
        }
    }

    yield put({
        type: 'notifications:update',
        payload: notifications,
    });
}

export function* read({ payload }) {
    let [user, notifications] = yield all([
        select(state => state.user),
        select(state => state.notifications),
    ]);
    sessionStorage.setItem('NCTimestamp', Math.floor(Date.now() / 60000) + 960);

    if (user.logged_in) {
        yield call(postJSON, `/api/notifications?codes[]=${payload.code.toLowerCase()}`, {});
        if (sessionStorage.getItem('NCIconLI') != 'viewed') {
            sessionStorage.setItem('NCIconLI', 'viewed');
        }

    } else {
        if (sessionStorage.getItem('NCIconLO') != 'viewed') {
            sessionStorage.setItem('NCIconLO', 'viewed');
        }
    }

    if (notifications) {
        const notificationsArray = [];
        const stateNC = user.logged_in ? 'NCLIState' : 'NCLOState';
        _.values(notifications).map(obj => {
            notificationsArray.push(obj);
        });
        const notification = { code: payload.code.toLowerCase(), viewed: true };

        if (notificationsArray.some(obj => obj.code == notification.code)) {
            notificationsArray[_.findIndex(notificationsArray, { code: notification.code })].viewed = true;
            notifications = notificationsArray;
        } else {
            notifications = [ notification, ...notificationsArray ];
        }

        if (sessionStorage.getItem(stateNC) != JSON.stringify(notifications)) {
            sessionStorage.removeItem(stateNC);
            sessionStorage.setItem(stateNC, JSON.stringify(notifications));
        }
    }

    yield put({
        type: 'notifications:update',
        payload: notifications,
    });
}

export function* root() {
    yield all([
        takeEvery('notifications:get', get),
        takeEvery('notifications:read', read),
    ]);
}
